<template>
  <button class="button" :class="getClass" @click="$emit('btnEvent')">
    <slot></slot>
  </button>
</template>

<script>
export default {
  props: {
    type: String,
    active: Boolean,
    light: Boolean,
    breath: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getClass () {
      return [
        this.type + '-btn',
        this.breath ? 'button__breath' : ''
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.button {
  color: #fff;
  text-transform: uppercase;
  @include flexrc;
  @include px2res(width, 237);
  @include px2res(height, 87);
  @include px2res(font-size, 34);
  // -webkit-text-stroke: 1px rgba(0, 0, 0, .3);
  transition: all .3s cubic-bezier(0.0,0.0,0.2,1);

  &.button__breath {
    filter: drop-shadow(0 0 8px #d75508);
  }
}
.button:disabled {
  filter: grayscale(100%)
}
.buy-btn {
  @include px2res(width, 116);
  @include px2res(height, 30);
  @include px2res(font-size, 28);
  @include px2res(border-radius, 2);
  color: #7f7e7e;
  background-color: #4b4b4b;
}
.buy-btn.active {
  color: #422411;
}
.buy-btn.blur {
  color: #7b7b7b;
  background-color: transparent;
}
.confirm-btn {
  @include px2res(width, 380);
  @include px2res(height, 62);
  @include px2res(font-size, 40);
}
.refresh-btn {
  @include px2res(width, 270);
  @include px2res(height, 70);
  background-size: 100% auto;
  margin: 0 auto;
}
.pool-btn {
  @include px2res(width, 270);
  @include px2res(height, 70);
  background-size: 100% auto;
  margin: 0 auto;
}
.spin-btn {
  @include px2res(width, 412);
  @include px2res(height, 62);
  animation: twinkle .8s ease-in-out both alternate infinite;
}
.spin-btn.dark {
  filter: grayscale(1) brightness(.86);
  animation: none;
}
@keyframes twinkle {
  0% {
    filter: brightness(1);;
  }
  100% {
    filter: brightness(1.25);;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Button.vue